/* eslint-disable */
import Axios from "axios";
import Cookies from "js-cookie";

export const postAsyncWithTokenFormData = (url, data) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: Cookies.get("autoketing_product_review_session"),
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
